import { render, staticRenderFns } from "./CashClients.vue?vue&type=template&id=7265c811&scoped=true&"
import script from "./CashClients.vue?vue&type=script&lang=js&"
export * from "./CashClients.vue?vue&type=script&lang=js&"
import style0 from "./CashClients.vue?vue&type=style&index=0&id=7265c811&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7265c811",
  null
  
)

export default component.exports